export default __webpack_public_path__ + "static/media/gifBox.c6ccd9d6.svg";